module.exports = __webpack_public_path__ + "img/logo.3b9d2336.svg";